export const copy = function (object) {
    return JSON.parse(JSON.stringify(object));
};